/**
 * Language resource for validation messages.
 * @typedef {Object} ValidationMessages
 * @property {string} noSpace - Validation message for cases where blank spaces are not allowed at the start and end.
 * @property {string} onlySpaces - Validation message for cases where the input consists only of spaces.
 */

/**
 * Language resource for validation messages.
 * @type {ValidationMessages}
 */
export const validation = {
  noSpace: 'No blank space is allowed at start and end',
  onlySpaces: 'Invalid text',
  type: 'Type is required',
  userIds: 'User are required',
  minOneUserIds: "At least one user is required",
  dateTime: "Date and time is required",
  message: "Message is required",
  authorName: "Author name is required",
  title: "Title is required",
  description: "Description is required",
};
